'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _utilsFactory = require('../utils/factory');

var _utilsFactory2 = _interopRequireDefault(_utilsFactory);

var moduleName = 'app.factories';

_angular2['default'].module(moduleName, []);

//.factory('xhr', Factory(xhrFactory))
exports['default'] = moduleName;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./resources/assets/js/src/modules/app.factories.js
 ** module id = 59
 ** module chunks = 0
 **/